import { useEffect, useRef, useState } from "react";
import { GlobalConfiguration } from "../../../../../utils/configurationProvider";
import CommonAssignLabelPopup from "../../../../_utils/CommonPopups/CommonAssignLabelPopup";
import { globalTextFormat } from "../../../../../utils/globalTextFormat";
import globalText from "../../../../../utils/globalText";
import DynamicAdditionalFields from "../../../../_utils/TransactionCommonComponents/DynamicAdditionalFields";
import AssignLabels from "../../../../_utils/AccountCreationComponents/AssignLabels";

// Add this at the top of TaxTransactionStepAdditionalDetails (outside the component)
const formatUIDate = (date) => {
  if (!date) return "";
  const d = new Date(date);
  return `${d.getDate()} ${d.toLocaleString("en-US", { month: "short" })}, ${d.getFullYear()}`;
};
const TaxTransactionStepAdditionalDetails = (props) => {
  const dropdownRefs = useRef(null);

  const [dropdowns, setDropdowns] = useState({});
  const labelActionDispatchedRef = useRef(false);
  const [loading, setLoading] = useState(false);
  const [showLabelModal, setShowLabelModal] = useState(false);
  const [selectedLabelsCreate, setSelectedLabelsCreate] = useState(() => {
    const initialLabels = [
      ...(props?.txnPayLoad?.labels || []),
      ...(props?.txnPayLoad?.ownerLabels || []),
    ];
    return [...new Set(initialLabels)];
  });
  const [labels, setLabels] = useState(() => {
    const initialLabels = [
      ...(props?.txnPayLoad?.labels || []),
      ...(props?.txnPayLoad?.ownerLabels || []),
    ];
    return [...new Set(initialLabels)];
  });

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const handleQuantityChange = (value, fieldname, data_type, key) => {
    if (value < 0 || String(value).length > 15) return;

    const numVal = value === "" ? "" : Number(value);

    // 1. Reset the Icon flags immediately on manual change
    props.setInitialRefactorAdditionalDetail((prev) => ({
      ...prev,
      [fieldname]: {
        ...prev[fieldname],
        isCopyDirect: false,
        isCopyClick: false,
      },
    }));

    props?.setQuantities((prev) => ({
      ...prev,
      [key]: numVal,
    }));

    handleInputChange({
      target: {
        name: fieldname,
        value: numVal,
        data_typeChan: data_type,
      },
    });
  };

  const handleTimeConfirm = (
    fieldname,
    data_type,
    hourShow,
    minuteShow,
    meridiemShow,
  ) => {
    handleInputChange({
      target: {
        name: fieldname,
        value: `${hourShow}:${minuteShow} ${meridiemShow}`,
        data_typeChan: data_type,
      },
    });
  };

  const handleInputChange = (e) => {
    if (e?.preventDefault) e.preventDefault();

    const name = e?.target?.name ?? e?.name;
    const value = e?.target?.value ?? e?.value;

    const field =
      props?.txnPayLoad?.selectedCategory?.configuration?.data?.find(
        (f) => f.name === name,
      );

    if (!field) return;

    let updatedData = { ...props.additionalData };

    switch (field.data_type) {
      case "month_year": {
        if (value?.month && value?.year) {
          const monthNumber = (
            months.indexOf(value.month) + GlobalConfiguration?.lengthCheckOne
          )
            .toString()
            .padStart(2, "0");
          updatedData[name] = `${monthNumber}/${value.year}`;
        } else {
          // 3. User cleared the dropdown
          updatedData[name] = "";
          // Manually trigger the icon reset if e.target is missing
          props.setInitialRefactorAdditionalDetail((prev) => ({
            ...prev,
            [name]: { ...prev[name], isCopyDirect: false, isCopyClick: false },
          }));
        }
        break;
      }

      case "from_year_to_year": {
        updatedData[name] = {
          from:
            value?.from !== undefined && value?.from !== ""
              ? Number(value.from)
              : null,
          to:
            value?.to !== undefined && value?.to !== ""
              ? Number(value.to)
              : null,
        };
        break;
      }

      case "date_range": {
        if (!value?.start_date || !value?.end_date) {
          updatedData[name] = null;
        } else {
          updatedData[name] = {
            start_date: value.start_date,
            end_date: value.end_date,
          };
        }
        break;
      }

      case "numeric": {
        const cleaned = String(value)
          .replace(/\D/g, "")
          .slice(
            GlobalConfiguration?.lengthCheckZero,
            GlobalConfiguration?.gstLength,
          );

        updatedData[name] = cleaned;
        break;
      }

      case "quantity": {
        updatedData[name] = String(value); // normalize to string
        break;
      }

      default: {
        updatedData[name] = value;
      }
    }

    props.setAdditionalData(updatedData);
  };

  const handleClose = (finalLabels) => {
    setShowLabelModal(false);
    if (!finalLabels) return;

    const currentOwnerLabels = props?.txnPayLoad?.ownerLabels || [];

    const newOwnerLabels = finalLabels?.filter((label) =>
      currentOwnerLabels?.includes(label),
    );
    const newOtherLabels = finalLabels?.filter(
      (label) => !currentOwnerLabels?.includes(label),
    );

    props?.setTxnPayLoad((prevPayload) => ({
      ...prevPayload,
      ownerLabels: newOwnerLabels,
      labels: newOtherLabels,
    }));
  };

  useEffect(() => {
    const handleClickOutside2 = (event) => {
      if (
        dropdownRefs.current &&
        !dropdownRefs.current.contains(event.target)
      ) {
        let obj = {
          ...dropdowns,
          isOpen: false,
        };
        setDropdowns(obj);
      }
    };

    document.addEventListener("mousedown", handleClickOutside2);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside2);
    };
  }, []);

  useEffect(() => {
    if (
      props?.copyData?.value !== "" &&
      props?.copyData?.title !== "" &&
      props?.copyData?.data_type === "time"
    ) {
      const timeStr = props?.copyData?.value;
      const [hourShow, rest] = timeStr.split(":");
      const [minuteShow, meridiemShow] = rest.split(" ");

      handleTimeConfirm(
        props?.copyData?.title,
        props?.copyData?.data_type,
        hourShow,
        minuteShow,
        meridiemShow,
      );

      props?.setTimeData((prev) => {
        const key = `${props?.copyData?.title}_${props?.copyData?.data_type}`;
        return {
          ...prev,
          [key]: { hours: hourShow, minutes: minuteShow },
        };
      });

      props?.setCopyData({
        title: "",
        value: "",
        data_type: "",
      });
    } else if (
      props?.copyData?.value !== "" &&
      props?.copyData?.title !== "" &&
      props?.copyData?.data_type === "date"
    ) {
      const key = `${props?.copyData?.title}_${props?.copyData?.data_type}`;
      const rawValue = props?.copyData?.value;

      // Parse the date string robustly
      // Try direct Date parse first, then strip commas as fallback
      let parsedDate = new Date(rawValue);
      if (isNaN(parsedDate.getTime())) {
        parsedDate = new Date(rawValue.replace(",", ""));
      }

      if (!isNaN(parsedDate.getTime())) {
        // Update additionalData with the formatted string (for comparison)
        handleInputChange({
          target: {
            name: props?.copyData?.title,
            value: formatUIDate(parsedDate), // store formatted string in additionalData
            data_typeChan: props?.copyData?.data_type,
          },
        });

        // Update startDate with the actual Date object (for calendar display)
        props?.setStartDate((prev) => ({
          ...prev,
          [key]: parsedDate,
        }));
      }

      props?.setCopyData({
        title: "",
        value: "",
        data_type: "",
      });
    } else if (
      props?.copyData?.value !== "" &&
      props?.copyData?.title !== "" &&
      props?.copyData?.data_type === "quantity"
    ) {
      handleQuantityChange(
        props?.copyData?.value || 0,
        props?.copyData?.title,
        props?.copyData?.data_type,
        `${props?.copyData?.title}_${props?.copyData?.data_type}`,
      );

      props?.setCopyData({
        title: "",
        value: "",
        data_type: "",
      });
    } else if (
      props?.copyData?.value !== "" &&
      props?.copyData?.title !== "" &&
      props?.copyData?.data_type === "toggle"
    ) {
      handleInputChange({
        target: {
          name: props?.copyData?.title,

          value: props?.copyData?.value,

          data_typeChan: props?.copyData?.data_type,
        },
      });

      props?.setCopyData({
        title: "",

        value: "",

        data_type: "",
      });
    } else if (
      props?.copyData?.value !== "" &&
      props?.copyData?.title !== "" &&
      props?.copyData?.data_type === "month_year"
    ) {
      handleInputChange({
        target: {
          name: props?.copyData?.title,

          value: props?.copyData?.value,

          data_typeChan: props?.copyData?.data_type,
        },
      });

      const [monthStr, yearStr] = props?.copyData?.value.split("/");

      const monthIndex = parseInt(monthStr, 10) - 1;

      const monthName = new Date(2000, monthIndex).toLocaleString("default", {
        month: "long",
      });

      const result = [monthName, parseInt(yearStr, 10)];

      props?.setSelectedValueMonth((prev) => {
        const key = `${props?.copyData?.title}_${props?.copyData?.data_type}`;

        return {
          ...prev,

          [key]: { month: result[0], year: result[1] },
        };
      });

      props?.setCopyData({
        title: "",

        value: "",

        data_type: "",
      });
    } else if (
      props?.copyData?.value !== "" &&
      props?.copyData?.title !== "" &&
      props?.copyData?.data_type === "from_year_to_year"
    ) {
      handleInputChange({
        target: {
          name: props?.copyData?.title,

          value: props?.copyData?.value,

          data_typeChan: props?.copyData?.data_type,
        },
      });

      props?.setSelectedValue((prev) => {
        const key = `${props?.copyData?.title}_${props?.copyData?.data_type}`;

        return {
          ...prev,

          [key]: {
            from: props?.copyData?.value?.from,

            to: props?.copyData?.value?.to,
          },
        };
      });

      props?.setCopyData({
        title: "",

        value: "",

        data_type: "",
      });
    } else if (
      props?.copyData?.value !== "" &&
      props?.copyData?.title !== "" &&
      props?.copyData?.data_type === "date_range"
    ) {
      props?.setCopyData({
        title: "",

        value: "",

        data_type: "",
      });
    }
  }, [props?.copyData]);

  useEffect(() => {
    if (!props.additionalData) return;

    const storeData =
      props.txnPayLoad.selectedCategory?.configuration?.data?.map((val) => {
        const dataValue = props.additionalData[val?.name];

        if (
          dataValue !== undefined &&
          (Array.isArray(dataValue)
            ? dataValue.length > GlobalConfiguration?.lengthCheckZero
            : dataValue !== "")
        ) {
          if (val?.data_type === "numeric") {
            const intVal = parseInt(
              dataValue,
              GlobalConfiguration?.searchHeight,
            );
            return isNaN(intVal) ? val : { ...val, value: intVal };
          }

          return { ...val, value: dataValue };
        }
        switch (val?.data_type) {
          case "multi_select_list":
            return { ...val, value: [] };

          case "toggle":
            return { ...val, value: false };

          case "hyperlink":
          case "upload":
            return { ...val, value: "" };

          case "time":
            return val;

          default:
            return val?.mandatory !== "Y" ? { ...val, value: "" } : val;
        }
      });

    props.setTxnPayLoad((prev) => ({
      ...prev,
      mergeCategory: storeData,
    }));
  }, [props?.additionalData, props?.txnPayLoad.selectedCategory]);

  useEffect(() => {
    const labelTxnRaw = sessionStorage.getItem("TaxAvailableLabels");
    const accountTxnRaw = sessionStorage.getItem("AvailableLabelsOwner");

    const txnLabels = labelTxnRaw ? JSON.parse(labelTxnRaw) : [];
    const accounLabels = accountTxnRaw ? JSON.parse(accountTxnRaw) : [];

    const initialLabels = [
      ...(props?.txnPayLoad?.labels || []),
      ...(props?.txnPayLoad?.ownerLabels || []),
      ...txnLabels,
      ...accounLabels,
    ];

    const uniqueLabels = [...new Set(initialLabels)];

    setLabels(uniqueLabels);
  }, []);

  useEffect(() => {
    if (!props?.txnPayLoad) return;

    const ownerLabels = props?.txnPayLoad?.ownerLabels || [];
    const labels = props?.txnPayLoad?.labels || [];

    const combined = [
      ...ownerLabels,
      ...labels.filter((label) => !ownerLabels.includes(label)),
    ];

    setSelectedLabelsCreate(combined);
  }, [props?.txnPayLoad?.ownerLabels, props?.txnPayLoad?.labels]);

  useEffect(() => {
    if (!props?.initialRefactorAdditionalDetail) return;

    Object.entries(props.initialRefactorAdditionalDetail).forEach(
      ([key, fieldMeta]) => {
        if (fieldMeta?.isCopyClick && fieldMeta?.isPaste) {
          const pasteDataType = fieldMeta?.isPaste?.data_type;

          if (pasteDataType === "hyperlink") {
            const value = fieldMeta.isPaste.value ?? "";
            const fieldKey = `${key}_hyperlink`;

            props?.setHyperLink((prev) => ({
              ...prev,
              [fieldKey]: value,
            }));

            handleInputChange({
              target: {
                name: key,
                value: value,
                data_type: "hyperlink",
              },
            });

            props?.setInitialRefactorAdditionalDetail((prev) => ({
              ...prev,
              [key]: {
                ...prev[key],
                isCopyClick: false,
                isPaste: {},
              },
            }));
          }
        }
      },
    );
  }, [props?.initialRefactorAdditionalDetail]);

  return (
    <>
      {showLabelModal && (
        <div className="fixed left-left-base w-width-full top-top-base h-height-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-max-zindex">
          <CommonAssignLabelPopup
            headerTitle="Assign/Unassign labels:"
            headersubtext="Labels will be used to generate statistics for the associated tax transactions."
            closehandleFunction={handleClose}
            closeisDisabled={false}
            labels={labels}
            setLabels={setLabels}
            isLabelPopupOpen={showLabelModal}
            setPayload={props?.setTxnPayLoad}
            txnPayLoad={props?.txnPayLoad}
            selectedLabelsCreate={selectedLabelsCreate}
            setSelectedLabelsCreate={(x) => {
              setSelectedLabelsCreate(x);
            }}
            labelActionDispatchedRef={labelActionDispatchedRef}
            loading={loading}
            setLoading={setLoading}
            type="create"
          />
        </div>
      )}
      <div
        className={`w-width-full flex flex-col Qlg:flex-row Qlg:px-padding-base px-padding-md gap-gap-md Qsmd:gap-gap-xl Qsmd:py-padding-md py-padding-md max-w-tab-width-normal mx-auto`}
      >
        <div
          className="w-width-full max-h-auto rounded-border-radius-md"
          style={{ scrollbarWidth: "none" }}
        >
          <div className="bg-primary-card py-padding-md h-auto flex flex-col px-padding-md items-start rounded-border-radius-md">
            <div className=" w-width-full text-text-primary font-semibold text-base flex flex-row justify-between">
              <p className="text-center pb-padding-md">
                {globalTextFormat(globalText?.ADDITIONAL_DETAILS, [
                  GlobalConfiguration?.lengthCheckZero,
                  GlobalConfiguration?.lengthCheckOne,
                ])}
              </p>
            </div>
            <div className="w-width-full lg:max-w-[var(--create-box-width)] flex flex-col gap-gap-md">
              <DynamicAdditionalFields
                mergeCategory={props?.txnPayLoad?.mergeCategory}
                additionalData={props.additionalData}
                setAdditionalData={props.setAdditionalData}
                hyperLink={props.hyperLink}
                setHyperLink={props.setHyperLink}
                timeData={props.timeData}
                setTimeData={props.setTimeData}
                quantities={props.quantities}
                setQuantities={props.setQuantities}
                uploadedFiles={props.uploadedFiles}
                setUploadedFiles={props.setUploadedFiles}
                startDate={props.startDate}
                setStartDate={props.setStartDate}
                endDate={props.endDate}
                setEndDate={props.setEndDate}
                selectedValue={props.selectedValue}
                setSelectedValue={props.setSelectedValue}
                selectedValueMonth={props.selectedValueMonth}
                setSelectedValueMonth={props.setSelectedValueMonth}
                initialRefactorAdditionalDetail={
                  props.initialRefactorAdditionalDetail
                }
                setInitialRefactorAdditionalDetail={
                  props.setInitialRefactorAdditionalDetail
                }
                previewImages={props.previewImages}
                setPreviewImages={props.setPreviewImages}
                onInputChanged={(name, value, type) => {
                  handleInputChange({
                    target: {
                      name,
                      value,
                      data_typeChan: type,
                    },
                  });
                }}
              />
            </div>
          </div>
        </div>
        <div className="h-auto w-width-full lg:max-w-[var(--create-box-width)] mb-margin-md">
          <AssignLabels
            setLabelpopup={setShowLabelModal}
            labels={selectedLabelsCreate}
            subText1={globalText?.LABELS_USAGE_NOTE}
            subText2="The labels below are auto assigned as per selected tax and owner accounts."
            isOptional={true}
          />
        </div>

        <div className="h-mobile-create-header w-width-full Qmd:hidden block my-margin-xl lg:my-margin-base"></div>
      </div>
    </>
  );
};

export default TaxTransactionStepAdditionalDetails;
